import { Badge } from 'reactstrap';

const STATUS_COLOR = {
  // Generic
  active: 'success',
  ready: 'success',
  ok: 'success',
  healthy: 'success',
  online: 'success',
  // Pending / warning
  pending: 'warning',
  awaiting_withdrawal_period: 'warning',
  trialing: 'info',
  past_due: 'warning',
  warning: 'warning',
  // Negative
  suspended: 'danger',
  failed: 'danger',
  cancelled: 'danger',
  revoked: 'danger',
  offline: 'danger',
  // Neutral
  deleted: 'secondary',
  closed: 'secondary',
  resolved: 'info',
  paid: 'success',
  open: 'primary',
  confirmed: 'success',
  // Roles
  customer: 'secondary',
  staff: 'info',
  admin: 'primary',
  owner: 'primary',
};

const LABELS = {
  awaiting_withdrawal_period: 'awaiting withdrawal',
  past_due: 'past due',
};

/**
 * Semantisch gefärbter Badge für Status- / Rollen-Strings.
 * Unbekannte Werte → graues `secondary`.
 */
export function StatusBadge({ value, pill = true }) {
  if (!value) return null;
  const color = STATUS_COLOR[value] ?? 'secondary';
  return (
    <Badge color={color} pill={pill} className="text-uppercase">
      {LABELS[value] ?? value}
    </Badge>
  );
}
